export const IP = 'https://api.cosvancouver.com';
